const TermsPage = ({ onBack }: { onBack: () => void }) => {
  return (
    <div className="portal portal-legal">
      <div className="card card-legal">
        <button className="back-btn" onClick={onBack} type="button">
          ← Zurück
        </button>

        <div className="brand">
          TAPETE
        </div>

        <h1 className="legal-h1">Nutzungsbedingungen</h1>
        <p className="legal-meta">Stand: Juni 2025</p>

        <div className="legal-section">
          <h2 className="legal-h2">§ 1 – Betreiber und Geltungsbereich</h2>
          <p>Diese Nutzungsbedingungen gelten für den kostenlosen Gäste-WLAN-Hotspot „Tapete .nett", bereitgestellt von:</p>
          <p className="legal-operator">
            Tapete Bar KG<br />
            Zentagasse 14, 1050 Wien<br />
            office@tapete.bar
          </p>
          <p>Das Gäste-WLAN ist eine kostenlose Nebenleistung zum Barbetrieb der Tapete Bar.</p>
        </div>

        <div className="legal-section">
          <h2 className="legal-h2">§ 2 – Leistungsbeschreibung</h2>
          <p>Der Betreiber stellt Gästen einen kostenlosen Internetzugang zur Verfügung. Es besteht kein Rechtsanspruch auf Verfügbarkeit, Bandbreite oder Erreichbarkeit bestimmter Dienste. Das WLAN kann jederzeit ohne Vorankündigung eingeschränkt oder eingestellt werden.</p>
        </div>

        <div className="legal-section">
          <h2 className="legal-h2">§ 3 – Nutzungsvoraussetzungen</h2>
          <p>Das WLAN ist ausschließlich Gästen der Tapete Bar gestattet und auf den Aufenthalt in den Räumlichkeiten beschränkt. Eine Weitergabe des Zugangs an Dritte ist nicht erlaubt.</p>
        </div>

        <div className="legal-section">
          <h2 className="legal-h2">§ 4 – Verbotene Nutzungen</h2>
          <p>Folgende Nutzungen sind ausdrücklich verboten:</p>
          <ul className="legal-list">
            <li>Illegale Downloads, Streaming oder Verbreitung urheberrechtlich geschützter Inhalte</li>
            <li>Betrieb von Filesharing- oder P2P-Netzwerken</li>
            <li>Versand von Spam, Phishing oder unerwünschten Massennachrichten</li>
            <li>Angriffe auf Geräte, Netzwerke oder IT-Systeme (z. B. Port-Scans, DoS-Angriffe)</li>
            <li>Verbreitung von Malware, Viren oder schädlichem Code</li>
            <li>Belästigung, Bedrohung oder Verleumdung anderer Personen</li>
            <li>Verbreitung oder Abruf strafbarer, sexuell expliziter oder extremistischer Inhalte</li>
            <li>Jede sonstige Nutzung, die gegen österreichisches oder europäisches Recht verstößt</li>
          </ul>
        </div>

        <div className="legal-section">
          <h2 className="legal-h2">§ 5 – Eigenverantwortung und Haftung</h2>
          <p>Die Nutzung erfolgt auf eigene Gefahr und Verantwortung. Der Betreiber haftet nicht für Schäden durch Datenverlust, Schadsoftware, Handlungen Dritter im Netzwerk oder Unterbrechungen des Dienstes. Für Schäden aus verbotener Nutzung haftet ausschließlich die nutzende Person.</p>
        </div>

        <div className="legal-section">
          <h2 className="legal-h2">§ 6 – Sperrung bei Missbrauch</h2>
          <p>Der Betreiber ist berechtigt, einzelne Geräte bei Verdacht auf Missbrauch oder Verstoß gegen diese Bedingungen ohne Vorankündigung zu sperren.</p>
        </div>

        <div className="legal-section">
          <h2 className="legal-h2">§ 7 – Änderungen</h2>
          <p>Es gilt die zum Zeitpunkt der Verbindung im Portal aktuelle Version dieser Nutzungsbedingungen.</p>
        </div>

        <button className="btn btn-outline" onClick={onBack} type="button">
          ← Zurück zum Portal
        </button>
      </div>
    </div>
  );
};

export default TermsPage;
